import { IUser } from '../entities/IUser';
import { httpClient } from './helper/httpClient';

export interface IChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

class UserService {
  private _baseURL = 'users';

  me(): Promise<IUser & { selectedTenantId: string }> {
    return httpClient.get<null, IUser & { selectedTenantId: string }>(
      `${this._baseURL}/me`,
    );
  }

  resetPassword(userId: string): Promise<void> {
    return httpClient.post<null, void>(
      `${this._baseURL}/${userId}/reset-password`,
    );
  }

  changePassword(data: IChangePasswordParams): Promise<void> {
    return httpClient.patch<null, void>(`${this._baseURL}/me/password`, {
      ...data,
    });
  }
}

export default new UserService();
